module.exports = "<div class=\"check-off-item\" [ngClass]=\"{'archived':item.archived,'checking':checking,'checked':checked}\" (click)=\"doCheckOff()\">\n\t{{item.name}} <span *ngIf=\"checking\"><i class=\"fa fa-spinner fa-pulse\"></i> Marking as checked off</span>\n\t<span *ngIf=\"checked\">CHECKED</span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/checkoffs/check-off-item/check-off-item.component.html
// module id = ./src/app/checkoffs/check-off-item/check-off-item.component.html
// module chunks = 0